import { theme } from '@prophecy/theme/theme';
import { tokens as TextTokens } from './../Typography/tokens';
export const tokens = {
    avatarBorderContrast: 'inset 0px 0px 0px 1px rgba(0, 0, 0, 8%)', // shadow
    radius: theme.radius.full,
    background: theme.colors.gray100,
    borderColor: theme.colors.gray100,
    text: {
        color: theme.colors.gray600,
        weight: theme.fontWeight.medium
    },
    sizes: {
        xs: {
            dimension: theme.sizes.x24,
            text: TextTokens.Text.level.xs,
            icon: {
                dimension: theme.sizes.x16
            },
            indicator: {
                dimension: theme.sizes.x6
            }
        },
        s: {
            dimension: theme.sizes.x32,
            text: TextTokens.Text.level.sm,
            icon: {
                dimension: theme.sizes.x20
            },
            indicator: {
                dimension: theme.sizes.x8
            }
        },
        m: {
            dimension: theme.sizes.x40,
            text: TextTokens.Text.level.md,
            icon: {
                dimension: theme.sizes.x24
            },
            indicator: {
                dimension: theme.sizes.x10
            }
        },
        l: {
            dimension: theme.sizes.x48,
            text: TextTokens.Text.level.lg,
            icon: {
                dimension: theme.sizes.x28
            },
            indicator: {
                dimension: theme.sizes.x12
            }
        },
        xl: {
            dimension: theme.sizes.x56,
            text: TextTokens.Text.level.xl,
            icon: {
                dimension: theme.sizes.x32
            },
            indicator: {
                dimension: theme.sizes.x14
            }
        },
        '2xl': {
            dimension: theme.sizes.x64,
            text: TextTokens.Display.level.xs,
            icon: {
                dimension: theme.sizes.x32
            },
            indicator: {
                dimension: theme.sizes.x16
            }
        }
    },
    AvatarGroup: {
        gap: theme.spaces.x8,
        outlineBorder: {
            width: '1.5px',
            color: theme.colors.white
        },
        sizes: {
            xs: {
                dimension: theme.sizes.x24,
                overlap: theme.sizes.x8,
                fontSize: theme.text.xs.fontSize,
                lineHeight: theme.text.xs.lineHeight
            },
            s: {
                dimension: theme.sizes.x32,
                overlap: theme.sizes.x10,
                fontSize: theme.text.sm.fontSize,
                lineHeight: theme.text.sm.lineHeight
            },
            m: {
                dimension: theme.sizes.x40,
                overlap: theme.sizes.x12,
                fontSize: theme.text.md.fontSize,
                lineHeight: theme.text.md.lineHeight
            }
        }
    },
    AvatarIndicator: {
        radius: theme.radius.full,
        outlineBorder: {
            width: '1.5px',
            color: theme.colors.white
        },
        status: {
            online: {
                color: theme.colors.success500
            },
            offline: {
                color: theme.colors.gray300
            },
            sizes: {
                xs: {
                    dimension: theme.sizes.x6
                },
                s: {
                    dimension: theme.sizes.x8
                },
                m: {
                    dimension: theme.sizes.x10
                },
                l: {
                    dimension: theme.sizes.x12
                },
                xl: {
                    dimension: theme.sizes.x14
                },
                '2xl': {
                    dimension: theme.sizes.x16
                }
            }
        },
        custom: {
            background: theme.colors.white,
            sizes: {
                xs: {
                    dimension: theme.sizes.x10
                },
                s: {
                    dimension: theme.sizes.x12
                },
                m: {
                    dimension: theme.sizes.x14
                },
                l: {
                    dimension: theme.sizes.x16
                },
                xl: {
                    dimension: theme.sizes.x18
                },
                '2xl': {
                    dimension: theme.sizes.x20
                }
            }
        }
    },
    AvatarProfilePhoto: {
        fontWeight: theme.fontWeight.semiBold,
        outlineBorder: {
            width: theme.spaces.x3,
            color: theme.colors.white
        },
        sizes: {
            s: {
                dimension: '72px',
                iconSize: theme.spaces.x36,
                fontSize: theme.display.sm.fontSize,
                lineHeight: theme.display.sm.lineHeight
            },
            m: {
                dimension: '96px',
                iconSize: theme.spaces.x48,
                fontSize: theme.display.md.fontSize,
                lineHeight: theme.display.md.lineHeight
            },
            l: {
                dimension: '160px',
                iconSize: theme.spaces.x80,
                fontSize: theme.display.xl.fontSize,
                lineHeight: theme.display.xl.lineHeight
            }
        }
    }
};
